// @flow

import React from 'react';
import styled from 'styled-components';
import { RichText } from 'components/Text';
import type { FreeCodeBlockData } from 'api/cms';
import emailSignupBlock from 'utils/styles/emailSignupBlock';

const StyledRichText = styled(RichText)`
  ${emailSignupBlock}
`;

const FreeCodeBlock = ({ data: { code } }: { data: FreeCodeBlockData }) => (
  // eslint-disable-next-line react/no-danger
  <StyledRichText dangerouslySetInnerHTML={{ __html: code }} tag="section" />
);

export default FreeCodeBlock;
